import { Control, FieldErrors } from 'react-hook-form';
import {
  StudyCategorySchema,
  StudyDetail,
  UpdateStudyDtoSchema,
} from '@aphp-ema/common/study';
import { z } from 'zod';

import { UseFormReturnType } from '@refinedev/react-hook-form';
import { HttpError } from '@refinedev/core';
import { validateCrossQuestionnaires } from '@aphp-ema/common/conditions';

export const StudyFormSchema = UpdateStudyDtoSchema.partial({
  initialQuestionnaire: true,
  emaQuestionnaires: true,
}).extend({
  category: StudyCategorySchema.nullable(),
});

export const PublishFormSchema = StudyFormSchema.superRefine(
  validateCrossQuestionnaires,
);

export type StudyFormValues = z.infer<typeof StudyFormSchema>;

export type StudyEditFormProps = UseFormReturnType<
  StudyDetail,
  HttpError,
  StudyFormValues
> & {
  publishButtonProps: {
    onClick: () => void;
    loading: boolean;
  };
  isPublishing: boolean;
  studyId: string;
  formLoading: boolean;
  isFirstLoading: boolean;
  publishModalProps: {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    patientCount: number;
    isLoading: boolean;
  };
  saveAndNavigate: (navigateTo: string) => Promise<boolean>;
};

export type ConsentUploaderProps = {
  control: Control<StudyFormValues>;
  errors: FieldErrors<StudyFormValues>;
  disabled: boolean;
};

export type TargetPopulationUploaderProps = {
  control: Control<StudyFormValues>;
  errors: FieldErrors<StudyFormValues>;
  disabled: boolean;
  studyId?: string;
  saveButtonProps?: {
    disabled: boolean;
    onClick: () => void;
  };
};
